module.exports = __webpack_public_path__ + "assets/img/IMG026.84e50f99.png";